import { render, staticRenderFns } from "./ProfileDesktop.vue?vue&type=template&id=79e86164&scoped=true"
import script from "./ProfileDesktop.vue?vue&type=script&lang=js"
export * from "./ProfileDesktop.vue?vue&type=script&lang=js"
import style0 from "./ProfileDesktop.vue?vue&type=style&index=0&id=79e86164&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e86164",
  null
  
)

export default component.exports